import Div from "@jumbo/shared/Div";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { getAllFinishedScrapped } from "app/redux/actions/inventoryAction";
import { getSizeList } from "app/services/apis/ListApi/SizeList";
import { getFinishItemNameList } from "app/services/apis/ListApi/itemNameList";
import { getPurchaseOrderList } from "app/services/apis/ListApi/purchaseOrderList";
import { getRakeDetailsList } from "app/services/apis/ListApi/rakeDetailsList";
import { downloadInventoryFinishedScrapReport } from "app/services/apis/ReportApis/InventoryScrapReport";
import { downloadInventoryWastageReport } from "app/services/apis/ReportApis/InventoryWastageReport";
import { supplierList } from "app/services/apis/supplierList";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const FinishedScrappedFilter = () => {
  const [supplierNameList, setSupplierNameList] = useState([]);
  const [purchaseOrderNo, setPurchaseOrderNo] = useState([]);
  const [itemNameList, setItemNameList] = useState([]);
  const [rakeDetails, setRakeDetails] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [inputs, setInputs] = useState({});
  const [resetAutocomplete, setResetAutocomplete] = useState(false);
  const { finishedScrapped, error, TotalPage } = useSelector(
    (state) => state.inventoryReducer
  );
  const dispatch = useDispatch();

  const handleFilter = () => {
    dispatch(getAllFinishedScrapped("", inputs, ""));
  };

  const handleClear = () => {
    dispatch(getAllFinishedScrapped("", "", 1));
    setInputs({});
    setResetAutocomplete((prev) => !prev);
  };

  useEffect(async () => {
    const data = await supplierList();
    if (data?.status == 200) {
      setSupplierNameList(data.data.result);
    }
    setPurchaseOrderNo(await getPurchaseOrderList());
    setRakeDetails(await getRakeDetailsList());
    setItemNameList(await getFinishItemNameList());
    setSizeList(await getSizeList());
  }, []);

  return (
    <>
      <Div sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 3 }}>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Item Name</Typography>
          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={itemNameList || []}
            // value={}
            getOptionLabel={(option) => option}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                finished_item_name: newValue ? newValue : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Size</Typography>

          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={sizeList || []}
            // value={}
            getOptionLabel={(option) => option}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                finished_size: newValue ? newValue : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Rack Details</Typography>
          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={rakeDetails || []}
            getOptionLabel={(option) => option}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                finished_rack_details: newValue ? newValue : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
          />
        </Div>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">PO No</Typography>

          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={purchaseOrderNo || []}
            // value={}
            getOptionLabel={(option) => option.purchase_order_no}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                purchase_order_no: newValue.purchase_order_no
                  ? newValue.purchase_order_no
                  : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.purchase_order_no}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
        <Div sx={{ width: "25%" }}>
          <Typography variant="h5">Supplier Name</Typography>
          <Autocomplete
            key={resetAutocomplete ? "reset1" : "normal1"}
            size="small"
            id="tags-standard"
            options={supplierNameList || []}
            // value={}
            getOptionLabel={(option) => option.supplier_name}
            onChange={(e, newValue) =>
              setInputs((values) => ({
                ...values,
                supplier_name: newValue.supplier_name
                  ? newValue.supplier_name
                  : null,
              }))
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.supplier_name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
      </Div>

      <Div
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 4,
          justifyContent: "space-between",
        }}
      >
        <Div>
          <Button
            size="small"
            variant="outlined"
            sx={{ p: 1, pl: 4, pr: 4, marginRight: 2 }} // Adjust marginRight for spacing
            onClick={handleFilter}
          >
            Apply
          </Button>
          <Button
            size="small"
            variant="outlined"
            sx={{ p: 1, pl: 4, pr: 4 }}
            onClick={handleClear}
          >
            Clear
          </Button>
        </Div>
        <Button
          disabled={finishedScrapped?.length == 0}
          variant="contained"
          onClick={async () => {
            const data = await downloadInventoryFinishedScrapReport(inputs);
            window.open(data);
          }}
        >
          Export CSV
        </Button>
      </Div>
    </>
  );
};

export default FinishedScrappedFilter;
